<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 11 11"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path :fill="iconColor" fill-rule="nonzero" d="M7.73 6.847l2.01 1.946a.578.578 0 0 1-.001.833.621.621 0 0 1-.863-.002L6.89 7.7a3.706 3.706 0 1 1 .841-.853zm-3.024.33a2.47 2.47 0 1 0 0-4.942 2.47 2.47 0 0 0 0 4.941z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
